import styles from "./styles.module.css";

const FilterSectionEmpty = () => {
  return <div className={styles.emptyPlaceholder}>No results.</div>;
};

export default FilterSectionEmpty;
